module.exports = __webpack_public_path__ + "img/404.5a7a5439.png";